// import Rx from 'rxjs/Rx'
// import {Observable} from 'rxjs'
import { Record } from 'immutable'
import { assign } from 'lodash'
// import Cookies from 'universal-cookie'
import { INIT } from '../../constants/phase'

import { combineEpics } from 'redux-observable'

import * as api from './api'

/***********************************
 * Action Types
 ***********/
// const cookies = new Cookies()

export const CREATE_OUTBOUNDACTIVITY = 'empire/outboundactivity/CREATE_OUTBOUNDACTIVITY'
export const CREATE_ORDER = "empire/outboundactivity/CREATE_ORDER";
export const FETCH_OUTBOUNDACTIVITIES = 'empire/outboundactivity/FETCH_OUTBOUNDACTIVITIES'
export const DELETE_OUTBOUNDACTIVITY = 'empire/outboundactivity/DELETE_RESOURCE'
export const DELETE_COMPLETED_OUTBOUNDACTIVITY = 'empire/outboundactivity/DELETE_RESOURCE'
export const UPDATE_OUTBOUNDACTIVITY = 'empire/outboundactivity/UPDATE_RESOURCE'
export const CREATE_CHARGE= "empire/outboundactivity/CREATE_CHARGE"
export const GET_OUTBOUNDACTIVITY_MATERIALS= "empire/outboundactivity/GET_OUTBOUNDACTIVITY_MATERIALS"
export const POST_OUTBOUNDACTIVITY_MATERIALS= "empire/outboundactivity/POST_OUTBOUNDACTIVITY_MATERIALS"
/***********************************
 * Initial State
 ***********/

// Unlike other ducks we are taking a class style approach
// for creating the InitialState. This is becuase we need to fetch the
// locally stored token in the constructor when it is created
const InitialStateInterface = {
  // We need this here to tell InitialState that there is a token key,
  // but it will be reset below to what is in localStorage, unless a value
  // is passed in when the object is instanciated
  data: {},
  token: null,
  phase: INIT,
  userPhase: INIT,
  user: null,
  error: null,
  message: null,
  loginPhase: INIT,
  sendVerificationCodePhase: INIT,
  sendVerificationCodeData: {}
}

class InitialState extends Record(InitialStateInterface) {
  constructor(desiredValues) {
    // When we construct InitialState, we automatically update it's default value
    // for token to be what is stored in localStorage
    const token = '' // localStorage.getItem(Config.LocalStorageKeys.Authorization)
    super(assign({ token }, desiredValues))
  }
}

/***********************************
 * Reducer
 ***********/
// eslint-disable-next-line complexity, max-statements

export default function (state = new InitialState(), action = {}) {
  switch (action.type) {
    default: {
      return state
    }
  }
}


/***********************************
 * Action Creators
 ***********/

export const createOutboundActivity = payload => {
  return {
    type: CREATE_OUTBOUNDACTIVITY,
    payload: api.createOutboundActivity(payload)
  }
}

export const fetchOutboundActivities = payload => {
  return {
    type: FETCH_OUTBOUNDACTIVITIES,
    payload: api.fetchOutboundActivities(payload)
  }
}

export const deleteOutboundActivity = payload => {
  return {
    type: DELETE_OUTBOUNDACTIVITY,
    payload: api.deleteOutboundActivity(payload)
  }
}
export const deleteCompletedOutboundActivity = payload => {
  return {
    type: DELETE_COMPLETED_OUTBOUNDACTIVITY,
    payload: api.deleteCompletedOutboundActivity(payload)
  }
}

export const getOutboundMaterials = payload => {
  return {
    type: GET_OUTBOUNDACTIVITY_MATERIALS,
    payload: api.getOutboundMaterials(payload)
  }
}

export const postOutboundMaterials = payload => {
  return {
    type: POST_OUTBOUNDACTIVITY_MATERIALS,
    payload: api.postOutboundMaterials(payload)
  }
}

export const updateOutboundActivity = payload => {
  return {
    type: UPDATE_OUTBOUNDACTIVITY,
    payload: api.updateOutboundActivity(payload)
  }
}

export const createOrder = payload => {
  return {
    type: CREATE_ORDER,
    payload: api.createOrder(payload)
  }
}

export const createCharge = payload => {
  return {
    type: CREATE_CHARGE,
    payload: api.createCharge(payload)
  }
}

/***********************************
 * Epics
 ***********************************/

export const outboundActivityEpic = combineEpics()
